<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="goodsspureport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
			</el-main>
		</el-container>
		<editcargo-Form ref="editcargoForm" :goodsUids="goodsUids" :currentrow="currentrow" @submit="editcargoSubmit" />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import editcargoForm from './lib/goodsspu/editcargo.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				goodsUids:[],
				currentrow:null,
				loading:false,
				reportName: 'goodsspu',
				foreingKey:{},
				list_formConfig: [{
					field: 'catagoryId',
					title: '分类',
					span: 6,
					itemRender: {
						name: '$emun',
						props:{
							cascader :true,
							name:'goodstype',
							formatter:'goodstype'
							
						}
					}
				},{
					field: 'goodsName',
					title: '名称',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'goodsCode',
					title: '编码',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			list(page,updateForm,other) {
				return new Promise(resolve => {
					this.$api.goods.listgoodsspu({
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},			
			list_beforeCreateGrid(gridOptions){
				gridOptions.id = 'goodsspu_list'
						gridOptions.pagerConfig.enabled = true
						gridOptions.columns = [			
							{type:'checkbox',title:'#',fixed:'left',width:50},
							{
								field: 'pic1',
								title: '图片',
								width:50,
								align:'center',	
								slots:{
									default:({row})=>{
										return <el-image style="width: 25px; height: 25px" src={row.pic1}  preview-src-list={[row.pic1]}></el-image>
									}
								},					
							},
							{field:'catagoryName',title:'分类',render:'$input',props:{show:true}},
							{field:'goodsCode',title:'编码',sortable:false,render:'',props:{show:true}},
							{field:'goodsName',title:'名称',render:'',props:{show:true}},
							{field:'cargotype',title:'项目类型',render:'',props:{show:true},sortable:false},
							{field:'cargoname',title:'项目名称',render:'',props:{show:true}},																			
							{
								title: '操作',
								fixed: "right",
								align: 'center',
								width: 130,
								slots: {
									default: ({row}) => {
										return [
											<el-button style="color:#67C23A" type = "text" size = "mini" onClick = {() => {this.cargoconfig(row)}}>项目配置</el-button>,
											// <el-button style="color:#F56C6C" type = "text" size = "mini" onClick = {() => {this.repurchase(row)}}>重新入库</el-button>,
											// <el-button type = "text" size = "mini" onClick = {() => {this.receipt(row)}}>回单</el-button>
										]
									}
								}
							}
						]
						gridOptions.checkboxConfig = null
						
						gridOptions.toolbarConfig.buttons = [{
							name: '导出',
							status: 'success',
							code: 'export'
						},{
							name: '项目配置',
							status: 'primary',
							code: 'batchcargoconfig'
						}]
			},
			batchcargoconfig(){
				let data = this.$refs.goodsspureport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.cargoconfig(data)
			},
			cargoconfig(row){
				let goodsUids = []
				if(!Array.isArray(row)){
					this.currentrow = row
					goodsUids = [row.goodsUid]
				}else{
					this.currentrow = null
					goodsUids = row.map((item)=>{
						return item.goodsUid
					})
				}
				this.goodsUids = goodsUids
				//console.log(row.id)
				this.$nextTick(()=>{
					this.$refs.editcargoForm.modal_show()
				})
				// data.forEach((item)=>{
				// 	this.loading = true
				// 	this.$api.reconciliation_bankflow.sendwln({
				// 			serialNo:item.serialNo,
				// 		}).then(()=>{
				// 		this.loading = false
				// 		this.customreload()
				// 	},()=>{
				// 		this.loading = false
				// 	})
				// })	
			},
			editcargoSubmit(){
				this.customreload()
			},
			sourcefile(row) {
				this.invoicedata = {
					customerId:row.customerId,
					invoiceNumber:row.invoiceNumber,
					invoiceId:row.invoiceId,
					invoiceType:0
				}
				this.tab = ['invoice']
				this.$nextTick(()=>{
					this.$refs.invoiceConfig.modal_show()
				})

				
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			edit(row){
				// if(row.relationtype == 1){
				// 	this.$message.error('自动关联的流水无法编辑')
				// 	return
				// }
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				this.$refs.goodsspureport.commitProxy('query')
			},
		},
		components: {
			editcargoForm
			// exportTable,
			// receiptIndex,
			// statisticsIndex,
			// editIndex
		}
	}
</script>